export const EMPLOYEE_TYPE = {
    FULL_TIME: 'FULL_TIME',
    PROBATION: 'PROBATION',
    PART_TIME: 'PART_TIME',
    CONTRACTOR: 'CONTRACTOR'
};
